import { createI18n } from 'vue-i18n'
import en from './en.json'
import sk from './sk.json'


export const i18n = createI18n({
    locale: 'sk',
    availableLocales: ['en', 'sk'],
    fallbackLocale: 'en',
    messages: {
        sk: sk,
        en: en,
    }
})